var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___eWlLbV",
  "hU": "SudoVerificationModal.module__unavailable___eWlLbV",
  "TJ": "SudoVerificationModal.module__unavailableTitle___eWlLbV",
  "$r": "SudoVerificationModal.module__unavailableBody___eWlLbV",
  "zc": "SudoVerificationModal.module__formError___eWlLbV",
  "kK": "SudoVerificationModal.module__passkeyHint___eWlLbV",
};

module.exports = exports;
